import {
  Box,
  Button,
  Grow,
  Paper,
  Popper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import FullScreenOverlay from "../../../components/full-screen-overlay";

type Props = {
  anchorRef: React.RefObject<HTMLButtonElement>;
  isOpen: boolean;
  onClose: () => void;
  currentGoal: number;
  onApply: (goal: number) => void;
};

const goalOptions = [
  {label: "5 questions / day", note: "Casual", value: 5},
  {label: "15 questions / day", note: "Regular", value: 15},
  {label: "30 questions / day", note: "Serious", value: 30},
  {label: "50 questions / day", note: "Intense", value: 50},
];

export default function EditGoalDropdown({
  anchorRef,
  isOpen,
  onClose,
  currentGoal,
  onApply,
}: Props) {
  const [selectedGoal, setSelectedGoal] = React.useState(currentGoal);

  const onGoalListItemClick = (goal: number) => {
    setSelectedGoal(goal);
    // onApply(goal);
    // onClose();
  };

  return (
    <>
      <FullScreenOverlay open={isOpen} onClick={onClose} />
      <Popper
        open={isOpen}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        transition
        disablePortal
        sx={{zIndex: 5}}>
        {({TransitionProps}) => (
          <Grow {...TransitionProps} style={{transformOrigin: "right top"}}>
            <Paper
              variant="feature"
              sx={{
                py: 2,
                px: 2,
                mt: 1,
                minWidth: "300px", // Increased width
              }}>
              <Stack spacing={2}>
                <Stack spacing={0}>
                  <Typography
                    variant="subtitle1"
                    sx={{fontWeight: "bold", textTransform: "uppercase"}}>
                    Edit Goal
                  </Typography>
                  <Typography variant="body2">
                    What&apos;s your daily learning goal?
                  </Typography>
                </Stack>

                <Stack spacing={1}>
                  {goalOptions.map(option => {
                    const isSelected = selectedGoal === option.value;
                    return (
                      <Button
                        key={option.value}
                        fullWidth
                        onClick={() => onGoalListItemClick(option.value)}
                        sx={{
                          // border: "0.75px solid",
                          border: "none",
                          // borderColor: isSelected ? "primary.dark" : "#DDDDDD",
                          backgroundColor: isSelected
                            ? "primary.main"
                            : "secondary.light",
                          color: isSelected
                            ? "primary.dark"
                            : "secondary.contrastText",
                          "&:hover": {
                            backgroundColor: isSelected
                              ? "primary.main"
                              : "action.hover",
                          },
                          justifyContent: "flex-start",
                          textAlign: "left",
                          px: 1.5,
                          py: 1.5,
                          fontWeight: 700,
                        }}
                        variant="outlined">
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          width="100%">
                          <Typography fontSize={"0.875rem"} fontWeight={500}>
                            {option.label}
                          </Typography>
                          <Typography fontSize={"0.875rem"} fontWeight={400}>
                            {option.note}
                          </Typography>
                        </Stack>
                      </Button>
                    );
                  })}
                </Stack>

                <Stack
                  mt={4}
                  direction="row"
                  justifyContent="space-between"
                  spacing={1}>
                  <Button size="small" onClick={onClose}>
                    Close
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                      onApply(selectedGoal);
                      onClose();
                    }}>
                    Change goal
                  </Button>
                </Stack>
              </Stack>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
